import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { SavedList } from '../../shared/saved-lists/saved-lists.service';

@Component({
    selector: 'app-save-list-modal',
    templateUrl: './save-list-modal.component.html',
    styleUrls: [],
    standalone: false
})
export class SaveListModalComponent {
  nameControl = new FormControl('', [Validators.required, Validators.minLength(1)]);

  constructor(
    public dialogRef: MatDialogRef<SaveListModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { list: SavedList }
  ) {
    if (data.list.name?.length > 0) {
      this.nameControl.setValue(`${data.list.name} (Modified)`);
    } else {
      this.nameControl.setValue(`Untitled Company List`);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.nameControl.valid && this.nameControl.value) {
      this.dialogRef.close({
        name: this.nameControl.value.trim(),
      });
    }
  }
}
